module.exports = __webpack_public_path__ + "img/Logo-ICFA-header.789ea99.png";